import { render, staticRenderFns } from "./ReturnTable.vue?vue&type=template&id=0700dd4a"
import script from "./ReturnTable.vue?vue&type=script&lang=js"
export * from "./ReturnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports